import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function OneTime() {
  const [result, setResult] = useState(null);

  const buy = async (service) => {
    const res = await fetch(API + '/payments/one-time?service=' + service, { method: 'POST' });
    const data = await res.json();
    setResult(data);
  };

  return (
    <div>
      <h2>One-Time Services</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12 }}>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>Express Audit</strong>
            <p style={{ color: '#94A3B8', fontSize: 13 }}>Full tax check for your company</p>
          </div>
          <button onClick={() => buy('express_audit')} style={{ padding: '8px 16px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>2 990 ₽</button>
        </div>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>Counterparty Deep Check</strong>
            <p style={{ color: '#94A3B8', fontSize: 13 }}>Full background check with court cases</p>
          </div>
          <button onClick={() => buy('deep_check')} style={{ padding: '8px 16px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>499 ₽</button>
        </div>
        <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <strong>Contract Review</strong>
            <p style={{ color: '#94A3B8', fontSize: 13 }}>AI-powered contract risk analysis</p>
          </div>
          <button onClick={() => buy('contract_review')} style={{ padding: '8px 16px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>1 990 ₽</button>
        </div>
      </div>
      {result && (
        <div style={{ marginTop: 16, padding: 14, background: '#10B981', color: '#fff', borderRadius: 8, textAlign: 'center' }}>
          {result.message}
        </div>
      )}
    </div>
  );
}

export default OneTime;